import { render, staticRenderFns } from "./PractitionerAdmin.vue?vue&type=template&id=174f0223"
import script from "./PractitionerAdmin.vue?vue&type=script&lang=js"
export * from "./PractitionerAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports